import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { TableRow, TableCell, Tooltip, IconButton } from "@material-ui/core"
import AssetCard from "../components/AssetCard"
import { Link } from "react-router-dom"
import { assetTypeValues } from "../../../constants"
import { Visibility } from "@material-ui/icons"
import { getLocalStorageInfo } from "../../../utils"
import config from '../../../config';
import FlightIcon from '@material-ui/icons/Flight';
import { assetType } from "../../../constants"
import { smbcInstance } from "../../../shared_elements/components"
const AssetList = ({ item, tabIndex }) => {
	const truncateString = (str, maxLength) => {
		if (str.length <= maxLength) {
			return str;
		}
		return str.substring(0, maxLength - 3) + "...";
	};

	const truncatedCountry = truncateString(item.country || "--", 18);
	const rowClick = item.asset_type === 1 ? `/${item.id}/${item.asset_type}/amp/list` : `/${item.id}/${item.asset_type}/tech_spec/list`

	return (
		<>
			{smbcInstance ?
				<TableRow hover tabIndex={-1} style={{ cursor: "pointer" }}>
					<TableCell component={Link} to={rowClick}><AssetCard item={item} /></TableCell>
					<TableCell component={Link} to={rowClick}>{item?.msn ? item?.msn : item?.asset_name || '--'}</TableCell>
					<TableCell component={Link} to={rowClick}>{item?.location_reg_aircraft || '--'}</TableCell>
					<TableCell component={Link} to={rowClick}>{item?.position?.label || '--'}</TableCell>
					<TableCell component={Link} to={rowClick}>{item?.operator?.name || '--'}</TableCell>
					<TableCell component={Link} to={rowClick}>{item.status && item.status.value === 1 ? (<p className="status on-lease">ON LEASE</p>) : null}
						{item.status && item.status.value === 2 ? (<p className="status off-lease">OFF LEASE</p>) : null}
						{item.status && item.status.value === 3 ? (<p className="status on-ground">On Ground</p>) : null}
						{item.status && item.status.value === 4 ? (<p className="status sold">WRITTEN OFF/ SOLD</p>) : null}
						{item.status && item.status.value === 5 ? (<p className="status archive">Archive</p>) : null}
						{item.status && item.status.value === 0 ? (<p className="status sold">Draft</p>) : null}
					</TableCell>
					<TableCell component={Link} to={rowClick}>{item?.on_wing_status ?  "On Wing" : "Off Wing"}</TableCell>
					{/* <TableCell component={Link} to={rowClick}>{item?.on_wing_status ? item?.on_wing_msn ? item?.on_wing_msn : "On Wing" : "Off Wing"}</TableCell> */}
					<TableCell component={Link} to={rowClick}>{item?.sub_status?.label || '--'}</TableCell>
					<TableCell>
						{assetTypeValues && assetTypeValues[item.asset_type] && assetTypeValues[item.asset_type].urlType ? (
							<>
								<ul className='list-inline'>
									<li className='list-inline-item' style={{ cursor: 'pointer', position: 'relative', marginRight: '7px' }}>
										<Tooltip title="Display Asset" arrow>
											<IconButton className="action-icon" component={Link} to={item?.asset_type === 1 ? `/${item.id}/${item.asset_type}/amp/list` : `/${item.id}/${item.asset_type}/tech_spec/list`}> <Visibility /></IconButton>
										</Tooltip>
									</li>
									{item?.asset_type === 2 ? null : <li className='list-inline-item' style={{ cursor: 'pointer', position: 'relative', }}>
										<Tooltip title='Technical Specification' arrow>
											<a href={`${config.domain.subDomian}technical-specification/${assetType[item.asset_type]}/${item.slug}`} target="_blank"><FlightIcon fontSize='small' color='primary' /></a>
										</Tooltip>
									</li>}
								</ul>
							</>) : null}
					</TableCell>
				</TableRow>
				:
				<TableRow hover tabIndex={-1} style={{ cursor: "pointer" }} >
					<TableCell component={Link} to={rowClick}><AssetCard item={item} /></TableCell>
					<TableCell component={Link} to={rowClick}>{item?.msn ? item?.msn : item?.asset_name || '--'}</TableCell>
					{tabIndex === 0 || tabIndex === 1 ? <TableCell component={Link} to={rowClick}>{item.current_registration_number ? item.current_registration_number : "--"}</TableCell> : null}
					{tabIndex === 0 || tabIndex === 1 ? <TableCell component={Link} to={rowClick}>{item?.lessor_name.name ? item?.lessor_name?.name : "--"}</TableCell> : null}
					{tabIndex === 0 || tabIndex === 1 ? <TableCell component={Link} to={rowClick}>{item.owner.name ? item.owner.name : "--"}</TableCell> : null}
					{tabIndex === 0 || tabIndex === 1 ? <TableCell component={Link} to={rowClick}><Tooltip title={item?.country ? item?.country : "--"} arrow><span>{truncatedCountry ? truncatedCountry : "--"}</span></Tooltip></TableCell> : null}
					{tabIndex === 2 ? <TableCell component={Link} to={rowClick}>{item?.lessee ? item?.lessee?.name : '--'}</TableCell> : null}
					{tabIndex === 2 ? <TableCell component={Link} to={rowClick}>{item?.operator?.name || '--'}</TableCell> : null}
					<TableCell component={Link} to={rowClick}>{item.status && item.status.value === 1 ? (<p className="status on-lease">ON LEASE</p>) : null}
						{item.status && item.status.value === 2 ? (<p className="status off-lease">OFF LEASE</p>) : null}
						{item.status && item.status.value === 3 ? (<p className="status on-ground">In Storage</p>) : null}
						{item.status && item.status.value === 4 ? (<p className="status sold">WRITTEN OFF/ SOLD</p>) : null}
						{item.status && item.status.value === 5 ? (<p className="status archive">Archive</p>) : null}
						{item.status && item.status.value === 0 ? (<p className="status sold">Draft</p>) : null}
					</TableCell>
					{tabIndex === 2 ? <TableCell component={Link} to={rowClick}>{item?.on_wing_status ? item?.on_wing_msn ? item?.on_wing_msn : "On Wing" : "Off Wing"}</TableCell> : null}
					<TableCell>
						{assetTypeValues && assetTypeValues[item.asset_type] && assetTypeValues[item.asset_type].urlType ? (
							<>
								<ul className='list-inline'>
									<li className='list-inline-item' style={{ cursor: 'pointer', position: 'relative', marginRight: '7px' }}>
										<Tooltip title="Display Asset" arrow>
											<IconButton className="action-icon" component={Link} to={item?.asset_type === 1 ? `/${item.id}/${item.asset_type}/amp/list` : `/${item.id}/${item.asset_type}/tech_spec/list`}> <Visibility /></IconButton>
										</Tooltip>
									</li>
									{item?.asset_type === 2 ? null : <li className='list-inline-item' style={{ cursor: 'pointer', position: 'relative', }}>
										<Tooltip title='Technical Specification' arrow>
											<a href={`${config.domain.subDomian}technical-specification/${assetType[item.asset_type]}/${item.slug}`} target="_blank"><FlightIcon fontSize='small' color='primary' /></a>
										</Tooltip>
									</li>}
								</ul>
							</>) : null}
					</TableCell>
				</TableRow>
			}
		</>
	)
}
export default withRouter(AssetList)